import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import compose from 'ramda/es/compose';
import curryN from 'ramda/es/curryN';
import { selectConfigDomain } from '../config/config.selectors';
import { getProp } from '../selectorHelpers';
import { extract } from '../../utils/cmsData';

export const selectFooterData = createSelector(
  selectConfigDomain,
  compose(
    curryN(1, fromJS),
    extract({
      color: getProp('footerColor'),
      form: getProp('footerForm'),
      contactTitle: getProp('contactTitle'),
      contact1Text: getProp('contact1Text'),
      contact1Icon: getProp('contact1Icon'),
      contact2Text: getProp('contact2Text'),
      contact2Icon: getProp('contact2Icon'),
      contact3Text: getProp('contact3Text'),
      contact3Icon: getProp('contact3Icon'),
      column2: getProp('column2'),
      column3: getProp('column3'),
      shopTitle: getProp('footerShopTitle'),
      shopText: getProp('footerShopText'),
      shopLink: getProp('footerShopLink'),
      shopImage: getProp('footerShopImage'),
      shopImageLink: getProp('footerShopImageLink'),
      image: getProp('footerImage'),
      socialIconList: getProp('bottomBarSocialIconList'),
      bottomBarLinks: getProp('bottomBarLinkList'),
      copyright: getProp('bottomBarCopyright'),
      photoDisclaimer: getProp('photoDisclaimer'),
      footerBadges: getProp('footerBadges'),
    }),
  ),
);

export const selectFooterContentType = createSelector(selectConfigDomain, getProp('contentType'));

export const selectFooterEntryId = createSelector(selectConfigDomain, getProp('entryId'));

export const selectCookieNoticeText = createSelector(selectConfigDomain, getProp('cookieNotice'));
